import { useEffect } from 'react'

import PropTypes from 'prop-types'

import { FetchHelper } from '../../helpers/fetch'

import { useSimpleState } from '../useSimpleState'

const useControlSearchAffiliates = (props={}) => {
    const {_state: _page} = useSimpleState(props.page || 1)

    const {_state: _results} = useSimpleState()

    const fetch = () => {
        if (props.beforeFetch)
            props.beforeFetch()

        return FetchHelper({
            url: `/api/v1/affiliates?page=${_page.get()}`
        })
            .then((res) => {
                if (res.status === 200) {
                    _results.set(res)
                }
            })
            .catch((res) => {
                console.log('control search affiliates fetch error', res)
            })
            .finally(() => {
                if (props.afterFetch)
                    props.afterFetch()
            })
    }

    // the public/list endpoint returns a DealResource-style shape, but a
    // single affiliate needs the dedicated GET /affiliates/{id} route —
    // there's no admin-scoped list to pull it from client-side
    const fetchGetAffiliate = (id) => {
        if (props.beforeFetch)
            props.beforeFetch()

        return FetchHelper({
            url: `/api/v1/affiliates/${id}`
        })
            .then((res) => {
                return res
            })
            .catch((res) => {
                return res
            })
            .finally(() => {
                if (props.afterFetch)
                    props.afterFetch()
            })
    }

    const fetchCreate = (body) => {
        if (props.beforeFetch)
            props.beforeFetch()

        return FetchHelper({
            url: '/api/v1/affiliates/post',
            options: {
                method: 'post',
                data: body
            }
        })
            .then((res) => {
                return res
            })
            .catch((res) => {
                return res
            })
            .finally(() => {
                if (props.afterFetch)
                    props.afterFetch()
            })
    }

    const fetchEdit = (body) => {
        if (props.beforeFetch)
            props.beforeFetch()

        return FetchHelper({
            url: '/api/v1/affiliates/update',
            options: {
                method: 'put',
                data: body
            }
        })
            .then((res) => {
                return res
            })
            .catch((res) => {
                return res
            })
            .finally(() => {
                if (props.afterFetch)
                    props.afterFetch()
            })
    }

    const fetchDelete = (item) => {
        if (props.beforeFetch)
            props.beforeFetch()

        return FetchHelper({
            url: '/api/v1/affiliates/delete',
            options: {
                method: 'put',
                data: {
                    id: item.id
                }
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    fetch()
                }

                return res
            })
            .catch((res) => {
                return res
            })
            .finally(() => {
                if (props.afterFetch)
                    props.afterFetch()
            })
    }

    const goToPage = (page) => {
        _page.set(page)
    }

    useEffect(() => {
        fetch()
    }, [_page.get()])

    return Object.freeze({
        _results,
        _page,
        _control: {
            fetch,
            fetchGetAffiliate,
            fetchCreate,
            fetchEdit,
            fetchDelete,
            goToPage
        }
    })
}

useControlSearchAffiliates.propTypes = {
    page: PropTypes.number,
    beforeFetch: PropTypes.func,
    afterFetch: PropTypes.func,
}

export { useControlSearchAffiliates }
